import { render, staticRenderFns } from "./VehicleSpecsComponent.vue?vue&type=template&id=711d1eec"
import script from "./VehicleSpecsComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleSpecsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports